/** 登录类型 */
export enum LOGIN_TYPE {
	/** 手机 */
	PHONE,
	/** 邮箱 */
	MAIL,
}

/** 登录平台 */
export enum LOGIN_PLATFORM {
	/** 玩家 */
	PLAYER = 1,
	/** 店主 */
	SHOPKEEPER,
}

/** 订单状态枚举 */
export enum ORDER_TYPE {
	/** 全部 */
	ALL = '99',
	/** 合买 */
	GROUP_BUY = '0',
	/** 待接单 */
	PENDING_ACCEPT = '1',
	/** 待出票 */
	PENDING_TICKET = '2',
	/** 合作 */
	COOPERATION = '3',
	/** 兑奖标记 */
	AWARD_MARK = '4',
}

/** 订单合作/跟单 */
export enum ORDER_DEFAULT {
	/** 合作 */
	COOPERATION = '0',
	/** 跟单 */
	FOLLOW = '1',
	/** 合买 */
	GROUP_BUY = '2',
}

/** 彩种 */
export enum LOTTERY {
	/** 竞彩足球 */
	COMPETITIVE_FOOTBALL = '竞彩足球',
	/** 竞彩篮球 */
	COMPETITIVE_BASKETBALL = '竞彩篮球',
	/** 胜负过关 */
	WIN_LOSS_PASS = '胜负过关',
	/** 北京单场 */
	BEIJING_SINGLE_FIELD = '北京单场',
	/** 双色球 */
	SSQ = '双色球',
	/** 大乐透 */
	DLT = '大乐透',
	/** 排列三 */
	PL3 = '排列三',
	/** 排列五 */
	PL5 = '排列五',
	/** 七星彩 */
	QXC = '七星彩',
	/** 七乐彩 */
	QLC = '七乐彩',
	/** 快乐八 */
	KL8 = '快乐八',
	/** 福彩3D */
	FC3D = '福彩3D',
	/** 任选九 */
	RX9 = '任选九',
	/** 胜负彩 */
	SFC = '胜负彩',
}

/** 订单状态 */
export enum ORDER_STATE {
	/** 认购中 */
	SUBSCRIPTION = '0',
	/** 待接单 */
	PENDING_ORDER = '1',
	/** 待出票 */
	PENDING_TICKET = '2',
	/** 玩家撤销 */
	PLAYER_REVOKES = '3',
	/** 店主撤销 */
	SHOP_OWNER_REVOKES = '4',
	/** 系统撤销 */
	SYSTEM_REVOKES = '5',
	/** 待开奖 */
	PENDING_DRAW = '6',
	/** 待中奖 */
	WAITING_TO_WIN = '7',
	/** 未中奖 */
	NOT_A_WINNING_TICKET = '8',
	/** 待派奖 */
	PENDING_AWARD = '9',
	/** 已派奖 */
	AWARD_ALREADY_AWARDED = '10',
	/** 已流单 */
	FLOW_ORDER = '11',
}
